import { styled, css, Card, Box, CardProps } from '@mui/material'
import { getUnitValue } from '../../../utils/processStyles'
import Grid from '../Grid'
import Heading from '../Heading'
import Icon from '../Icon'
import Image from '../Image'
import ViewObserver from '../ViewObserver/ViewObserver'
import { CategoryListCardProps } from './CategoryList.types'

export const CategoryListWrapper = styled(Grid)(() => css``)
CategoryListWrapper.defaultProps = {
  columns: 2,
  gap: 12
}

export const CategoryListCard = styled(Card, {
  shouldForwardProp: (prop) => !['horizontal'].includes(String(prop))
})<CardProps & CategoryListCardProps>(
  ({ padding, gap, radius, horizontal }) => css`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: ${getUnitValue(padding)};
    gap: ${getUnitValue(gap)};
    border-radius: ${getUnitValue(radius)};

    ${horizontal &&
    css`
      flex-direction: row;
      align-items: center;
    `}
  `
)
CategoryListCard.defaultProps = {
  elevation: 3,
  gap: 12,
  padding: 16
}

export const CategoryListContent = styled(Box)(
  () => css`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  `
)

export const CategoryListImage = styled(Image)(() => css``)
CategoryListImage.defaultProps = {
  size: 48,
  radius: 8
}

export const CategoryListHeading = styled(Heading)(() => css``)
CategoryListHeading.defaultProps = {
  variant: 'h2'
}

export const CategoryListIcon = styled(Icon)(
  ({ theme }) => css`
    color: ${theme.palette.primary.main};
  `
)
CategoryListIcon.defaultProps = {
  size: 24
}

export const CategoryListObserver = styled(ViewObserver)(() => css``)
CategoryListObserver.defaultProps = {
  offset: 20
}
